import { render, staticRenderFns } from "./SurveyFooterMenu.vue?vue&type=template&id=00c3170f&scoped=true&"
import script from "./SurveyFooterMenu.vue?vue&type=script&lang=js&"
export * from "./SurveyFooterMenu.vue?vue&type=script&lang=js&"
import style0 from "./SurveyFooterMenu.vue?vue&type=style&index=0&id=00c3170f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c3170f",
  null
  
)

export default component.exports